import { Typography } from '@mui/material';
import PublicToolLayout from '../../components/public-tools/PublicToolLayout';
import ToolWidget from '../../components/public-tools/ToolWidget';

export default function GscOwnerVerificationPage() {
  return (
    <PublicToolLayout title="GSC Verification Signals">
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Google Search Console Verification Signals
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Detect Google Search Console DNS TXT and HTML meta verification signals. Their presence
        does not confirm an active Search Console property or your current access to it.
      </Typography>
      <ToolWidget
        scanType="GSC_OWNER"
        formLabel="Website URL"
        formPlaceholder="https://example.com"
      />
    </PublicToolLayout>
  );
}
